import { Stack } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';
import usePaywall from '../paywall/usePaywall';
import pluralize from 'pluralize';

const PaywallDashboardHeader = () => {
  const { daysLeft } = usePaywall();

  if (!daysLeft) {
    return null;
  }

  return (
    <Stack alignItems="flex-end">
      <Typography variant="caption" color={colors.grey[900]} whiteSpace="nowrap">
        Free trial
      </Typography>
      <Typography whiteSpace="nowrap" variant="caption" color={colors.grey[700]}>
        {daysLeft} {pluralize('day', daysLeft)} left
      </Typography>
    </Stack>
  );
};

export default PaywallDashboardHeader;
